import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getPodMutationQueryKey } from 'hooks/queries/autoscaler/usePodMutationQuery';
import { getPodMutationsQueryKey } from 'hooks/queries/autoscaler/usePodMutationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useDeletePodMutationMutation = (
  onSuccess?: () => void
): UseMutationResult<AxiosResponse, unknown, string, unknown> => {
  const { currentOrganization } = useOrganizations();
  const { cluster } = useCluster();

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiClient.autoscaler.deletePodMutation({
        clusterId: cluster.id,
        organizationId: currentOrganization!.id,
        id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getPodMutationsQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getPodMutationQueryKey(),
      });
      onSuccess?.();
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
